import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

export type Sidebars = "home" | "add-master" | "staffs" | "buildings" | "matching" | "history" | null;

interface SidebarMenuState {
  sidebarIsOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  modifySidebarIsOpen: boolean;
  setModifySidebarIsOpen: (isOpen: boolean) => void;
  toggleModifySidebar: () => void;
}

export const useSidebarMenuStore = create<SidebarMenuState>()(
  devtools(
    persist(
      (set, get) => ({
        sidebarIsOpen: true,
        setIsOpen: (isOpen: boolean) => set(() => ({ sidebarIsOpen: isOpen })),
        modifySidebarIsOpen: false,
        setModifySidebarIsOpen: (isOpen: boolean) => set(() => ({ modifySidebarIsOpen: isOpen })),
        toggleModifySidebar: () => set(() => ({ modifySidebarIsOpen: !get().modifySidebarIsOpen })),
      }),
      { name: "sm-sidebarStateStore" },
    ),
  ),
);
